export function getEnumKeyByValue<T extends { [index: string]: string }>(
    enumerated: T,
    value: string
) {
    return Object.keys(enumerated)[Object.values(enumerated).indexOf(value)];
}
